import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EditorAnimationFrame } from '../../domain';
import {
  CollapsibleImageListPanelComponent,
  ImageListItem,
  ImageListPanelLabels,
} from '../side-panel/collapsible-image-list-panel';

@Component({
  selector: 'lib-animation-frame-panel',
  imports: [CollapsibleImageListPanelComponent, TranslateModule],
  templateUrl: './animation-frame-panel.component.html',
  styleUrl: './animation-frame-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnimationFramePanelComponent {
  readonly frames = input<EditorAnimationFrame[]>([]);
  readonly processing = input(false);

  readonly filesSelected = output<File[]>();
  readonly frameReordered = output<AnimationFrameReorderEvent>();
  readonly frameDurationChanged = output<AnimationFrameDurationEvent>();
  readonly frameDeleted = output<string>();
  readonly frameDuplicated = output<string>();

  protected readonly labels: ImageListPanelLabels = {
    titleKey: 'EDITOR.ANIMATION.FRAMES_TITLE',
    expandKey: 'EDITOR.ANIMATION.ACTIONS.EXPAND',
    collapseKey: 'EDITOR.ANIMATION.ACTIONS.COLLAPSE',
    addKey: 'EDITOR.ANIMATION.ACTIONS.ADD_FRAMES',
    emptyKey: 'EDITOR.ANIMATION.EMPTY_FRAMES',
    duplicateKey: 'EDITOR.ANIMATION.ACTIONS.DUPLICATE_FRAME',
    deleteKey: 'EDITOR.ANIMATION.ACTIONS.DELETE_FRAME',
  };

  protected readonly isSourceFrame = (index: number): boolean => index === 0;
  protected readonly canMutateFrame = (index: number): boolean => index > 0;

  protected onDurationChanged(item: ImageListItem, event: Event): void {
    event.stopPropagation();
    const inputElement = event.target as HTMLInputElement;
    this.frameDurationChanged.emit({
      id: item.id,
      durationMs: Number(inputElement.value),
    });
  }
}

export interface AnimationFrameReorderEvent {
  id: string;
  position: number;
}

export interface AnimationFrameDurationEvent {
  id: string;
  durationMs: number;
}
